"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.svgElementsFillCurrentColor = exports.center = void 0;
var center = exports.center = "\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n";
var svgElementsFillCurrentColor = exports.svgElementsFillCurrentColor = "\n  circle,\n  ellipse,\n  line,\n  path,\n  polygon,\n  polyline,\n  rect {\n    fill: currentColor !important;\n  }\n";
//# sourceMappingURL=helpers.js.map